import dynamic from "next/dynamic";

import { twMerge } from "tailwind-merge";

import useEscapeKey from "hooks/useEscapeKey";

const ToolRelativeValueHistory = dynamic(
  () => import("components/ToolRelativeValueHistory"),
  { ssr: false }
);

const ToolRelativeValueHistoryModal = ({
  pairId,
  pairRecord: pairRecordProp,
  onClose,
}: {
  pairId?: string;
  pairRecord?: any;
  onClose?: () => void;
}) => {
  useEscapeKey(() => onClose?.());

  const pairRecord = pairRecordProp || { pairId };

  return (
    <div className="pt-[5px] px-[15px] pb-[15px] h-full">
      <button
        className={twMerge(
          "absolute top-[-5px] right-[10px]",
          "border-0 bg-transparent text-[40px]",
          "text-shady-gray hover:text-active-black"
        )}
        onClick={onClose}
      >
        ×
      </button>
      {pairRecord && <ToolRelativeValueHistory pairRecord={pairRecord} />}
    </div>
  );
};

export default ToolRelativeValueHistoryModal;
